module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/app/app.component.css
// module id = ./src/app/components/app/app.component.css
// module chunks = main